import { createAction } from "@reduxjs/toolkit";
import {
  UPDATING_GROUP_REQUEST,
  UPDATING_GROUP_SUCCEEDED,
  UPDATING_GROUP_FAILED,
  DELETING_GROUP_REQUEST,
  DELETING_GROUP_SUCCEEDED,
  DELETING_GROUP_FAILED,
  FETCHING_GROUP_REQUEST,
  FETCHING_GROUP_SUCCEEDED,
  FETCHING_GROUP_FAILED,
  FETCHING_GROUP_CHILDREN_REQUEST,
  FETCHING_GROUP_CHILDREN_SUCCEEDED,
  FETCHING_GROUP_CHILDREN_FAILED,
  DELETING_ASSET_FROM_GROUP_REQUEST,
  DELETING_ASSET_FROM_GROUP_SUCCEEDED,
  DELETING_ASSET_FROM_GROUP_FAILED,
  GROUP_UPDATE_PROPERTY,
  CREATING_GROUP_IN_GROUP,
  CREATING_GROUP_IN_GROUP_SUCCEEDED,
  CREATING_GROUP_IN_GROUP_FAILED,
  ADD_ASSET_TO_GROUP,
  ADD_ASSET_TO_GROUP_SUCCEEDED,
  ADD_ASSET_TO_GROUP_FAILED,
  INVALIDATE_GROUP_CHILDREN_FETCHED,
  SORTING_GROUP,
  INVALIDATE_GROUP_CHILDREN
} from "./actionTypes";

import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { AddAssetToGroup, AddAssetToGroupFailed, AddAssetToGroupSucceeded, CreateGroup, CreateGroupFailed, CreateGroupSucceeded, DeleteAssetFromGroup, DeleteAssetFromGroupFailed, DeleteAssetFromGroupSucceeded, DeleteGroupFailed, DeleteGroupRequest, DeleteGroupSucceeded, FetchGroupChildren, FetchGroupChildrenFailed, FetchGroupChildrenSucceeded, FetchGroupFailed, FetchGroupRequest, FetchGroupSucceeded, SortGroupRequest, UpdateGroupFailed, UpdateGroupPropertyRequest, UpdateGroupRequest, UpdateGroupSucceeded } from "../../types/groups";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const GROUPS_BASE_URL = `${apiUrl}/api/2.0/groups`;
const GROUPS_BASE_URL_V1 = `${apiUrl}/api/2.1/groups`;
const GROUPS_BASE_URL_V2 = `${apiUrl}/api/2.2/groups`;

//fetch group
export const fetchGroup = createAction<FetchGroupRequest>(FETCHING_GROUP_REQUEST);

const fetchingGroupSuccedded = createAction<FetchGroupSucceeded>(FETCHING_GROUP_SUCCEEDED);

const fetchingGroupFailed = createAction<FetchGroupFailed>(FETCHING_GROUP_FAILED);

const fetchGroupSaga = function* (action: ReturnType<typeof fetchGroup>): any {

  const groupId = action.payload.id;

  const url = new URL(`${GROUPS_BASE_URL_V1}/${groupId}`);

  const fetchGroupAPI = () => {
    return axios({
      method: "GET",
      url: url.toString()
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGroupAPI);
    yield put(fetchingGroupSuccedded({group: response, id: groupId}));
  } catch (error) {
    yield put(fetchingGroupFailed({error, id: groupId}));
  }
};

export const invalidateFetchingChildrenForGroup = createAction<{id: string}>(INVALIDATE_GROUP_CHILDREN_FETCHED);
//fetch group children
export const fetchGroupChildren = createAction<FetchGroupChildren>(FETCHING_GROUP_CHILDREN_REQUEST);

const fetchingGroupChildrenSuccedded = createAction<FetchGroupChildrenSucceeded>(FETCHING_GROUP_CHILDREN_SUCCEEDED);

const fetchingGroupChildrenFailed = createAction<FetchGroupChildrenFailed>(FETCHING_GROUP_CHILDREN_FAILED);


const fetchGroupChildrenSaga = function* (action: ReturnType<typeof fetchGroupChildren>): any {

  const groupId = action.payload.id;
  const page =  action.payload.page;
  const limit = action.payload.limit;
  const sort = action.payload.sort.order;
  const type = action.payload.sort.type;

  const url = new URL(`${GROUPS_BASE_URL_V2}/${groupId}/children`);

  let params = {
    page,
    limit,
    sort,
    type
  };

  const fetchGroupChildrenAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
      params: params

    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGroupChildrenAPI);
    yield put(fetchingGroupChildrenSuccedded({entities: response.records, groupId, currentPage: response.currentPage, totalPages: response.totalPages}));
  } catch (error) {
    yield put(fetchingGroupChildrenFailed({error, groupId}));
  }
};

//update group

export const updateGroup = createAction<UpdateGroupRequest>(UPDATING_GROUP_REQUEST);

const updatingGroupSucceeded = createAction<UpdateGroupSucceeded>(UPDATING_GROUP_SUCCEEDED);

const updatingGroupFailed = createAction<UpdateGroupFailed>(UPDATING_GROUP_FAILED);

const updateGroupSaga = function* (action: ReturnType<typeof updateGroup>): any {

  const streamId = action.payload.streamId;
  const groupId = action.payload.entity.id;
  const parentId = action.payload.parent;
  const type = action.payload.type;
  const event = action.payload.event;

  const url = new URL(`${GROUPS_BASE_URL}/${groupId}`);

  const updateAssetAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
      data: action.payload.entity
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    const payload = {
        group: response,
        streamId: streamId,
        parentId: parentId
    }
    yield put(updatingGroupSucceeded(payload));
    if(type === "rename"){
      event({streamId: streamId, groupId: groupId})
    }
  } catch (error) {
    yield put(updatingGroupFailed({error, streamId, parentId}));
  }
};

export const deleteGroup = createAction<DeleteGroupRequest>(DELETING_GROUP_REQUEST);

const deletingGroupSucceeded = createAction<DeleteGroupSucceeded>(DELETING_GROUP_SUCCEEDED);

const deletingGroupFailed = createAction<DeleteGroupFailed>(DELETING_GROUP_FAILED);

const deleteGroupSaga = function* (action: ReturnType<typeof deleteGroup>): any {

  const group = action.payload.id;
  const streamId = action.payload.streamId;
  const groupId = action.payload.groupId;

  const url = new URL(`${GROUPS_BASE_URL}/${group}`);

  const updateAssetAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
      data: group
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    yield put(deletingGroupSucceeded({group, streamId, groupId}));
  } catch (error) {
    yield put(deletingGroupFailed({error, streamId, groupId}));
  }
};

//delete asset from group

export const deleteAssetFromGroup = createAction<DeleteAssetFromGroup>(DELETING_ASSET_FROM_GROUP_REQUEST);

export const deletingAssetFromGroupSuccedded = createAction<DeleteAssetFromGroupSucceeded>(DELETING_ASSET_FROM_GROUP_SUCCEEDED);

export const deletingAssetFromGroupFailed = createAction<DeleteAssetFromGroupFailed>(DELETING_ASSET_FROM_GROUP_FAILED);

const deleteAssetFromGroupSaga = function* (action: ReturnType<typeof deleteAssetFromGroup>): any {

  const asset = action.payload.assets;
  const groupId = action.payload.groupId;
  const event = action.payload.event;
  const sourceCta = action.payload.sourceCta;

  const url = new URL(`${GROUPS_BASE_URL}/${groupId}/assets`);

  const deleteAssetFromGroupAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
      data: asset
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAssetFromGroupAPI);
    yield put(deletingAssetFromGroupSuccedded({response, groupId}));
    event({response, sourceCta});
  } catch (error) {
    yield put(deletingAssetFromGroupFailed({error, groupId}));
  }
};

//update group
export const updateGroupProperty = createAction<UpdateGroupPropertyRequest>(GROUP_UPDATE_PROPERTY);

//create group
export const createGroup = createAction<CreateGroup>(CREATING_GROUP_IN_GROUP);

export const createGroupSucceeded = createAction<CreateGroupSucceeded>(CREATING_GROUP_IN_GROUP_SUCCEEDED);

export const createGroupFailed = createAction<CreateGroupFailed>(CREATING_GROUP_IN_GROUP_FAILED);

  const createGroupSaga = function* (action: ReturnType<typeof createGroup>): any {
      
      const streamId = action.payload.streamId;
      const groupId = action.payload.groupId;
      const upsert = false;
  
      const url = new URL(`${GROUPS_BASE_URL}/${groupId}`);

      let param = {
        name : action.payload.groupName,
        upsert: upsert
      }
  
      const createGroupAPI = () => {
        return axios({
          method: "POST",
          url: url.toString(),
          params: param
        }).then((response) => response.data);
      };
  
      try {
        const response = yield call(createGroupAPI);
        yield put(createGroupSucceeded({group: response, streamId, parentId: groupId}));
      } catch (error) {
        yield put(createGroupFailed({error, streamId, groupId}));
      }
    }

//add asset to group
export const addAssetToGroup = createAction<AddAssetToGroup>(ADD_ASSET_TO_GROUP);

export const addAssetToGroupSucceeded = createAction<AddAssetToGroupSucceeded>(ADD_ASSET_TO_GROUP_SUCCEEDED);

export const addAssetToGroupFailed = createAction<AddAssetToGroupFailed>(ADD_ASSET_TO_GROUP_FAILED);

const addAssetToGroupSaga = function* (
  action: ReturnType<typeof addAssetToGroup>,
): any {
  const request = action.payload;

  const url = new URL(`${GROUPS_BASE_URL}/${request.groupId}/assets`);

  const addAssetToStreamAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: request.assets
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetToStreamAPI);
    yield put(addAssetToGroupSucceeded({assets: response, groupId: request.groupId}));
  } catch (error) {
    yield put(addAssetToGroupFailed({error, groupId: request.groupId}));
  }
}

//sort stream
export const sortGroup = createAction<SortGroupRequest>(SORTING_GROUP);

const sortGroupSaga = function* (): any {

};

//invalidate group children
export const invalidateGroupChildren = createAction<string>(INVALIDATE_GROUP_CHILDREN);


export default function* groupsSaga() {
  yield takeEvery(UPDATING_GROUP_REQUEST, updateGroupSaga);
  yield takeEvery(DELETING_GROUP_REQUEST, deleteGroupSaga);
  yield takeEvery(FETCHING_GROUP_REQUEST, fetchGroupSaga);
  yield takeEvery(FETCHING_GROUP_CHILDREN_REQUEST, fetchGroupChildrenSaga);
  yield takeEvery(DELETING_ASSET_FROM_GROUP_REQUEST, deleteAssetFromGroupSaga);
  yield takeEvery(CREATING_GROUP_IN_GROUP, createGroupSaga);
  yield takeEvery(ADD_ASSET_TO_GROUP, addAssetToGroupSaga);
  yield takeEvery(SORTING_GROUP, sortGroupSaga);
}
